/** Etapas do fluxo pós-cadastro: escolha de plano → checkout → confirmação. */

export const SUBSCRIPTION_FLOW_STEP_PROFILE = 'Perfil';
export const SUBSCRIPTION_FLOW_STEP_PLAN = 'Plano';
export const SUBSCRIPTION_FLOW_STEP_PAYMENT = 'Pagamento';
export const SUBSCRIPTION_FLOW_STEP_CONFIRMATION = 'Confirmação';

export type SubscriptionFlowActiveStep = 1 | 2 | 3 | 4;
